import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { RfqConsultancyServicesComponent } from './rfq-consultancy-services/rfq-consultancy-services.component';
import { RfqConstructionWorkComponent } from './rfq-construction-work/rfq-construction-work.component';
import { RfqTechnicalSubmissionComponent } from './rfq-technical-submission/rfq-technical-submission.component';
import { RfqCommercialSubmissionComponent } from './rfq-commercial-submission/rfq-commercial-submission.component';
import { RfqConclusionComponent } from './rfq-conclusion/rfq-conclusion.component';
import { ActivatedRoute } from '@angular/router';
import { RequestForQuotationService } from '@/app/services/tendering-services/rfq/rfq.service';
@Component({
  imports: [
    CommonModule,
    RfqConsultancyServicesComponent,
    RfqConstructionWorkComponent,
    RfqTechnicalSubmissionComponent,
    RfqCommercialSubmissionComponent,
    RfqConclusionComponent,
  ],
  standalone: true,
  selector: 'app-rfq-section-dialogs',
  templateUrl: './rfq-section-dialogs.component.html',
  styleUrls: ['./rfq-section-dialogs.component.css'],
})
export class RfqSectionDialogsComponent implements OnInit {
  @Input() tendererResponse: any;
  @Output() closeModalEvent = new EventEmitter<boolean>();
  currentStep = 1;
  project_name: string;
  tenderType: string;
  isEdit = false;
  tendererResponseData: any = [];

  constructor(
    private ProjectsService: ProjectsService,
    private RequestForQuotationService: RequestForQuotationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.RequestForQuotationService.isEdit$.subscribe((state) => {
      this.isEdit = state;
    });
    this.RequestForQuotationService.tenderType$.subscribe((state) => {
      this.tenderType = state;
    });
    if (this.tendererResponse) {
      this.mapRFPExistingData();
    }
  }

  nextStep() {
    if (this.currentStep < 5) {
      this.currentStep++;
    }
  }
  previousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
      this.RequestForQuotationService.setEditState(true);
    }
  }

  handleCloseModal(closeModalValue: boolean) {
    if (closeModalValue) {
      this.closeModalEvent.emit(closeModalValue); // Emit closeModal value to the parent
    }
  }

  handleConstructionWorksEmittedData(constructionWorksData: any) {
    this.tendererResponseData['sitePreparation'] =
      constructionWorksData?.site_preparation;
    this.tendererResponseData['civilWorks'] =
      constructionWorksData?.structural_civil_works;
    this.tendererResponseData['mepWorks'] = constructionWorksData?.mep_works;
    this.tendererResponseData['fitOut'] =
      constructionWorksData?.finishing_fitout;
    this.tendererResponseData['healthSafety'] =
      constructionWorksData?.health_safety_compliance;
    this.tendererResponseData['postConstruction'] =
      constructionWorksData?.post_construction_activities;

    this.tendererResponseData['sitePreparationAttachments'] =
      constructionWorksData?.site_preparation_attachments;
    this.tendererResponseData['healthSafetyAttachments'] =
      constructionWorksData?.health_safety_attachments;
    this.tendererResponseData['civilWorksAttachments'] =
      constructionWorksData?.structure_civil_attachments;

    // TODO: set rfp response id in service here
  }

  handleConsultancyServiceEmittedData(constructionWorksData: any) {
    this.tendererResponseData['projectManagement'] =
      constructionWorksData?.project_management;
    this.tendererResponseData['designServices'] =
      constructionWorksData?.design_services;
    this.tendererResponseData['costConsultancy'] =
      constructionWorksData?.cost_consultancy;
    this.tendererResponseData['contractAdministration'] =
      constructionWorksData?.contract_administration;
    this.tendererResponseData['riskManagement'] =
      constructionWorksData?.risk_management;
    this.tendererResponseData['sustainabilityCompliance'] =
      constructionWorksData?.sustainability_compliance;
    this.tendererResponseData['finalSustainabilityCompliance'] =
      constructionWorksData?.final_sustainability_compliance;

    // TODO: set rfp response id in service here
  }

  handleTechnicalSubmissionEmittedData(technicalSubmissionData: any) {
    this.tendererResponseData['hasEnvironmentalPlan'] =
      Number(technicalSubmissionData?.has_environmental_plan) || 0;
    this.tendererResponseData['environmentalPlanDescription'] =
      technicalSubmissionData?.environmental_plan_description;
    this.tendererResponseData['hasTechnicalDeviations'] =
      Number(technicalSubmissionData?.has_technical_deviations) || 0;
    this.tendererResponseData['technicalDeviationsDescription'] =
      technicalSubmissionData?.technical_deviations_description;
    this.tendererResponseData['projectProgramme'] =
      technicalSubmissionData?.project_programme;
    this.tendererResponseData['healthSafetyPlan'] =
      technicalSubmissionData?.health_safety_plan;
    this.tendererResponseData['technicalProposal'] =
      technicalSubmissionData?.technical_proposal;
    this.tendererResponseData['relevantExperience'] = JSON.parse(
      technicalSubmissionData.relevant_experience
    );

    this.tendererResponseData['cvsOfKeyPersonnelsAttachments'] =
      technicalSubmissionData?.cvs_of_key_personnels_attachments;

    // TODO: set rfp response id in service here
  }

  handleCommercialSubmissionEmittedData(commercialSubmissionData: any) {
    this.tendererResponseData['priceBreakdownTitle'] =
      commercialSubmissionData?.price_breakdown_title;
    this.tendererResponseData['priceBreakdownDescription'] =
      commercialSubmissionData?.price_breakdown_description;
    this.tendererResponseData['financialStabilityDescription'] =
      commercialSubmissionData?.financial_stability_description;
    this.tendererResponseData['contractualComments'] =
      commercialSubmissionData?.contractual_comments;

    this.tendererResponseData['performanceBondGuaranteeAttachments'] =
      commercialSubmissionData?.performance_bond_guarantee_attachments;
    this.tendererResponseData['financialStabilityAttachments'] =
      commercialSubmissionData?.financial_stability_attachments;
    this.tendererResponseData['proofOfInsuranceAttachments'] =
      commercialSubmissionData?.proof_of_insurance_attachments;

    // TODO: set rfp response id in service here
  }
  handleConclusionSubmissionEmittedData(conclusionSubmissionData: any) {
    this.tendererResponseData['tendererCompanyName'] =
      conclusionSubmissionData?.tenderer_company_name;
    this.tendererResponseData['tendererContactInformation'] =
      conclusionSubmissionData?.tenderer_contact_information;
    this.tendererResponseData['tendererName'] =
      conclusionSubmissionData?.tenderer_name;
    this.tendererResponseData['tendererPosition'] =
      conclusionSubmissionData?.tenderer_position;

    // TODO: set rfp response id in service here
  }

  mapRFPExistingData() {
    this.handleConstructionWorksEmittedData(this.tendererResponse);
    this.handleConsultancyServiceEmittedData(this.tendererResponse);
    this.handleTechnicalSubmissionEmittedData(this.tendererResponse);
    this.handleCommercialSubmissionEmittedData(this.tendererResponse);
    this.handleConclusionSubmissionEmittedData(this.tendererResponse);
    this.calculateCurrentStep();
  }
  calculateCurrentStep() {
    // Check if all required data is available and assign values conditionally
    if (
      this.tenderType === 'consultancy services' &&
      !this.tendererResponse?.project_management &&
      !this.tendererResponse?.design_services &&
      !this.tendererResponse?.cost_consultancy &&
      !this.tendererResponse?.contract_administration &&
      !this.tendererResponse?.risk_management &&
      !this.tendererResponse?.sustainability_compliance &&
      !this.tendererResponse?.final_sustainability_compliance
    ) {
      this.currentStep = 1;
    } else if (
      this.tenderType === 'construction works' &&
      !this.tendererResponse?.site_preparation &&
      !this.tendererResponse?.structural_civil_works &&
      !this.tendererResponse?.mep_works &&
      !this.tendererResponse?.finishing_fitout &&
      !this.tendererResponse?.health_safety_compliance &&
      !this.tendererResponse?.post_construction_activities &&
      !this.tendererResponse?.site_preparation_attachments &&
      !this.tendererResponse?.health_safety_attachments &&
      !this.tendererResponse?.structure_civil_attachments
    ) {
      this.currentStep = 1;
    } else if (!this.tendererResponse?.technical_proposal) {
      this.currentStep = 2;
    } else if (!this.tendererResponse?.price_breakdown_title) {
      this.currentStep = 3;
    } else if (
      !this.tendererResponse?.tenderer_name &&
      !this.tendererResponse?.tenderer_position
    ) {
      this.currentStep = 4;
    } else {
      this.currentStep = 1;
    }
  }
}
